import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-arrow-more',
    templateUrl: './icon-arrow-more.component.html',
    styleUrls: ['./icon-arrow-more.component.scss']
})
export class IconArrowMoreComponent implements OnInit {

    @Input() cssClass: string;

    constructor() { }

    ngOnInit(): void {
    }

}
